import React, {useEffect, useState} from 'react';
import {connect} from "react-redux";
import * as auth from "../Auth";
import {Link} from "react-router-dom";
import {getWallets} from "../Auth/_redux/authCrud";
import {PriceColumnFormatter} from "../Sale/pages/card/card-table/column-formatters";
import BootstrapTable from "react-bootstrap-table-next";
import {NoRecordsFoundMessage} from "../../../_metronic/_helpers";
import {ChargeWalletDialog} from "./components/ChargeWalletDialog";


function WalletPage(props) {

    const [wallets, setWallets] = useState([]);
    const [showDialog, setShowDialog] = useState(false);


    const fetchWallets = async () => {
        const result = await getWallets();
        setWallets(result.data);
    }

    useEffect(() => {
        fetchWallets();
    }, []);

    const columns = [
        {
            dataField: "branchName",
            text: "نام شعبه"
        },
        {
            dataField: "amount",
            text: "موجودی کیف پول",
            formatter: PriceColumnFormatter,
        }
    ]

    return (
        <div className={"card card-custom"}>
            {/* begin::Header */}
            <div className="card-header py-3">
                <div className="card-title align-items-start flex-column">
                    <h3 className="card-label font-weight-bolder text-dark">
                        کیف پول من
                    </h3>
                </div>
                <div className="card-toolbar">
                    <button
                        className="btn btn-primary mr-2"
                        onClick={() => setShowDialog(true)}
                    >
                        شارژ کیف پول
                    </button>
                </div>
            </div>
            <div className={"card-body"}>
                <BootstrapTable
                    wrapperClasses={"table-responsive"}
                    classes={"table table-head-custom table-vertical-center overflow-hidden"}
                    bootstrap4
                    bordered={true}
                    remote
                    data={wallets}
                    keyField="branchName"
                    columns={columns}
                    >
                    <NoRecordsFoundMessage entities={wallets}/>
                </BootstrapTable>
            </div>
            {/* end::Header */}

            <ChargeWalletDialog show={showDialog} onHide={() => setShowDialog(false)}/>
        </div>
    )
}

export default connect(null, auth.actions)(WalletPage);